// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { AUTH_STORAGE_KEY, authStorage } from '@/lib/authPersistence';

const DEFAULT_SUPABASE_URL = 'https://jxyfrrsypkmdhylsdjlx.supabase.co';
const DEFAULT_SUPABASE_PUBLISHABLE_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imp4eWZycnN5cGttZGh5bHNkamx4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM0OTY2NTQsImV4cCI6MjA4OTA3MjY1NH0.W0B-IALtHzC7UaZzvRYbqFPWBltmUPGyOIvk4C7CdEo';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || DEFAULT_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY =
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || DEFAULT_SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: authStorage,
    storageKey: AUTH_STORAGE_KEY,
    persistSession: true,
    autoRefreshToken: true,
  }
});
